import { axios } from "~/plugins/request";

export const state = () => {
    return {};
};
export const mutations = {};
export const actions = {
    // 学生综合素质测评数据报表1
    findReport1List({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/careerTraitAssessment/getCareerResultList`,params)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    exportReport1({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/careerTraitAssessment/exportExcelReport1`,params)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },


    // 学生综合素质测评数据报表2
    findReport2List({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/careerTraitAssessment/getCareerTraitAssessmentVoList`,params)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    exportReport2({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/careerTraitAssessment/exportCareerTraitAssessmentData`,params)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    // 省份下拉选
    getProvinceVoList({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/careerTraitAssessment/getProvinceVoList`)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

};
